import { stats } from '@/mocks/stats';
import type { FC } from 'react';

const StatsSection: FC = () => {
  return (
    <section id="stats" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4">
            <i className="ri-bar-chart-line text-sm"></i>
            <span>Statystyki</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Kakobuy Spreadsheet w liczbach
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300 text-center animate-fade-in-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;